<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
   
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-3 d-flex flex-wrap align-items-center gap-2">
            <label class="mb-0 text-nowrap" for="transferDate">Jour de virement :</label>
            <input
              id="transferDate"
              v-model="transferDate"
              type="date"
              class="form-control w-auto"
              @change="getClients"
            />
            <button
              type="button"
              class="btn text-nowrap"
              :class="transferDate ? 'btn-outline-secondary' : 'btn-secondary'"
              @click="showAllDates"
            >
              Toutes les dates
            </button>
          </div>
          <p class="small text-muted">
            <template v-if="transferDate">
              Magasins dont le jour de virement est le <b>{{ formatDay(transferDate) }}</b> :
              {{ dueClients.length }} sur {{ clientList.length }}.
            </template>
            <template v-else>Tous les magasins avec des colis à facturer.</template>
          </p>
        </div>
        <div class="col-12">
          <div class="form-group mb-3">
            <label>Magasins :</label>
            <v-select
              class="custom-select-height"
              v-model="client"
              :options="dueClients"
              label="store"
              @update:modelValue="handleAgencySelection"
            >
              <template #option="{ store, nb_colis, transfer_days_label }">
                <span>{{ store }} - {{ nb_colis }} Colis</span>
                <small class="text-muted ms-2">(Virement : {{ transfer_days_label }})</small>
              </template>
              <template #no-options>Aucun magasin à virer ce jour</template>
            </v-select>
          </div>
        </div>
        <div class="col-12">
          <button
            style="float: right;"
            v-if="auth.can('ADD_INV')"
            variant="btn btn-primary"
            @click="addInvoice"
            class="btn btn-primary"
          >
            Ajouter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import moment from "moment";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import router from "@/router";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    // State for selected client
    const client = ref(null);

    // Dummy client list; replace with your actual data source
    const clientList = ref([]);

    // Handle agency selection
    const handleAgencySelection = (selected: any) => {
      client.value = selected;
    };

    // Add invoice handler
    async function addInvoice() {
      if (!client.value || !client.value.customer) {
        showToast("Merci de remplir tous les champs", "error");
        return;
      }
      const data = new FormData();
      data.append("cstmr", client.value.customer);
      data.append("user_id", user.id);
      data.append("user_name", user.name);

      try {
        const res = await api.post("/api/auth/add_invoice", data);
        if (res.data.message === "success") {
          const routeData = {
            name: "EditInvoicePage",
            params: { id: res.data.Inv.id , refNote: res.data.Inv.invoice_ref },
          };
          window.open(router.resolve(routeData).href, "_blank");
        } else {
          showToast("Une erreur est survenue, veuillez réessayer.", "error");
        }
      } catch (error) {
        showToast("Une erreur est survenue, veuillez réessayer.", "error");
      }
    }

    // Defaults to today: only the stores whose transfer days include that date
    const transferDate = ref(moment().format("YYYY-MM-DD"));
    const dueClients = computed(() =>
      transferDate.value ? clientList.value.filter((c: any) => c.due) : clientList.value
    );

    function formatDay(value: string) {
      const days = ["", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];
      const date = moment(value);
      return `${days[date.isoWeekday()]} ${date.format("DD/MM/YYYY")}`;
    }

    async function getClients() {
      try {
        const response = await api.get(`/api/auth/list_cstmr_invoices`, {
          params: transferDate.value ? { date: transferDate.value } : {},
        });
        if (response && response.data) {
          clientList.value = response.data;
          if (client.value && !dueClients.value.some((c: any) => c.customer === (client.value as any).customer)) {
            client.value = null;
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }

    function showAllDates() {
      transferDate.value = "";
      getClients();
    }

    onMounted(getClients);

    return {
      transferDate,
      dueClients,
      formatDay,
      getClients,
      showAllDates,
      client,
      clientList,
      handleAgencySelection,
      auth,
      addInvoice,
    };
  },
});
</script>
